import { ReactElement } from 'react'

import MotoristaRepository from 'modules/motorista/infra/repositories/MotoristaRepository'
import ListMotoristas from 'modules/motorista/pages/ListMotoristas'

import DeleteMotoristaImpl from '../../domain/usecases/DeleteMotorista'
import FindByCpfNomeFrotistaIdImpl from '../../domain/usecases/FindByCpfNomeFrotistaId'
import GetImagemMotoristaImpl from '../../domain/usecases/GetImagemMotorista'

export const ListMotoristaFactory = (): ReactElement => {
  const motoristaRepository = new MotoristaRepository()
  const findByCpfNomeFrotistaId = new FindByCpfNomeFrotistaIdImpl(
    motoristaRepository,
  )
  const deleteMotorista = new DeleteMotoristaImpl(motoristaRepository)
  const getImagemMotorista = new GetImagemMotoristaImpl(motoristaRepository)

  return (
    <ListMotoristas
      findByCpfNomeFrotistaId={findByCpfNomeFrotistaId}
      deleteMotorista={deleteMotorista}
      getImagemMotorista={getImagemMotorista}
    />
  )
}
